// extracted by mini-css-extract-plugin
module.exports = {"D_4":"D_D_4__jy_24"};